import { lazy } from 'react';
import WithSuspense from '../Utils/HOCs/withSuspense';
import { constants } from '../Configs/constants';

const urls = constants.urls;

export const routes = [
  {
    path: urls.MAIN,
    title: 'pagrindinis',
    navLink: true,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/Main'))),
    auth: false,
  },
  {
    path: urls.OBJECTS,
    title: 'visi objectai',
    navLink: true,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/ObjectCategory'))),
    auth: false,
  },
  {
    path: urls.OBJECT_CATEGORY,
    title: 'objectai',
    navLink: false,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/ObjectCategory'))),
    auth: false,
  },
  {
    path: urls.OBJECT_ITEM,
    title: 'object',
    navLink: false,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/ObjectPage'))),
    auth: false,
  },
  {
    path: urls.SALES,
    title: 'noriu pirkti/parduoti',
    navLink: true,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/AdvertPage'))),
    auth: false,
  },
  {
    path: urls.ABOUT,
    title: 'apie mus',
    navLink: true,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/Main'))),
    auth: false,
  },
  {
    path: urls.CAREER,
    title: 'karjera',
    navLink: true,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/CareerPage'))),
    auth: false,
  },
  {
    path: urls.CAREER_ITEM,
    title: 'karjera',
    navLink: false,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/CareerItemPage'))),
    auth: false,
  },
  {
    path: urls.VIDEO,
    title: 'video',
    navLink: true,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/VideoPage'))),
    auth: false,
  },
  {
    path: urls.CONTACTS,
    title: 'kontaktai',
    navLink: true,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/Main'))),
    auth: false,
  },
  {
    path: urls.CONFIRM_MAIL,
    title: 'mail confirmation',
    navLink: false,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/ConfirmMailPage'))),
    auth: false,
  },
  {
    path: urls.DASHBOARD,
    title: 'admin',
    navLink: false,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/Dashboard'))),
    auth: true,
  },
  {
    path: urls.CONSOLE_PROFILE,
    title: 'Profilis',
    sidebarLink: true,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/ProfilePage'))),
    auth: true,
    roles: ['admin', 'broker'],
  },
  {
    path: urls.CONSOLE_OBJECTS,
    title: 'Objektai',
    sidebarLink: true,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/ObjectCategoryAdminPage'))),
    auth: true,
    roles: ['admin', 'broker'],
  },
  {
    path: urls.CONSOLE_OBJECTS_CREATE,
    title: 'Objekt',
    sidebarLink: false,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/AdminObjectPage'))),
    auth: true,
    roles: ['admin', 'broker'],
  },
  {
    path: urls.CONSOLE_OBJECTS_UPDATE,
    title: 'Objekt',
    sidebarLink: false,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/AdminObjectPage'))),
    auth: true,
    roles: ['admin', 'broker'],
  },
  {
    path: urls.CONSOLE_USERS,
    title: 'NT brokerė',
    sidebarLink: true,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/BrokersPage'))),
    auth: true,
    roles: ['admin'],
  },
  {
    path: urls.CONSOLE_USER,
    title: 'NT broker',
    sidebarLink: false,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/BrokerProfilePage'))),
    auth: true,
    roles: ['admin'],
  },
  {
    path: urls.CONSOLE_PARTNERS,
    title: 'Partneriai',
    sidebarLink: true,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/PartnersPage'))),
    auth: true,
    roles: ['admin'],
  },
  {
    path: urls.CONSOLE_CAREER,
    title: 'Karjera',
    sidebarLink: true,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/CareerAdminPage'))),
    auth: true,
    roles: ['admin'],
  },
  {
    path: urls.CONSOLE_CAREER_NEW,
    title: 'Karjera',
    sidebarLink: false,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/CareerAdminCreationPage'))),
    auth: true,
    roles: ['admin'],
  },
  {
    path: urls.CONSOLE_CAREER_ITEM,
    title: 'Karjera',
    sidebarLink: false,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/CareerAdminItemPage'))),
    auth: true,
    roles: ['admin'],
  },
  {
    path: urls.CONSOLE_COUNTRIES,
    title: 'Geo',
    sidebarLink: true,
    exact: true,
    comp: WithSuspense(lazy(() => import('../Pages/CountriesPage'))),
    auth: true,
    roles: ['admin'],
  },
];
